import { computed } from 'vue';
import type { FlowTokenModel } from './useFlowTokenModelsCondition';

type EmptyValueOption = {
  text: string;
  value: string;
};

export const useFlowTokenForm = (
  model: FlowTokenModel,
  emptyValue: EmptyValueOption,
) => {
  const selected = computed({
    get: () =>
      model.selected.map((item) =>
        item === emptyValue.value
          ? emptyValue
          : {
              text: item,
              value: item,
            },
      ),
    set: (value: Array<string | EmptyValueOption>) => {
      model.selected = value.map((item) => (typeof item === 'string' ? item : item.value));
    },
  });

  const hasEmpty = computed({
    get: () => model.selected.some((item) => item === emptyValue.value),
    set: (value: boolean) => {
      if (!value) {
        model.selected = model.selected.filter((item) => item !== emptyValue.value);
      } else if (!model.selected.some((item) => item === emptyValue.value)) {
        model.selected = model.selected.concat([emptyValue.value]);
      }

      model.include_empty = value;
    },
  });

  return {
    selected,
    hasEmpty,
  };
};
